import { TableContainer } from "../../../DemandaCriada/styles";
import { Alteracao } from "../../types";

interface BlocoAlteracoesProps {
    alteracoes: Alteracao[];
    idPendencia?: number;
}

export default function BlocoAlteracoes({ alteracoes, idPendencia }: BlocoAlteracoesProps) {
    if (!alteracoes || alteracoes.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">
                Pendência
                {idPendencia && <span style={{ marginLeft: '8px', color: 'var(--c64748b)', fontWeight: 'normal' }}> #{String(idPendencia).padStart(4, '0')}</span>}
            </h4>
            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col-three">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        {alteracoes.map((alteracao, index) => (
                            <tr key={index}>
                                <td className="field-cell">{alteracao.campo}</td>
                                <td className="before-cell">{alteracao.antes || "—"}</td>
                                <td className="after-cell">{alteracao.depois || "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}

